import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { IID_OL_SUPPORTO } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIdOlSupportoState extends EntityState<IID_OL_SUPPORTO, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_OL_SUPPORTO })
@InterfaceDataStore(InterfaceName.INSTALLAZIONE)
export class IIDolSupportoStore extends EntityStore<IIdOlSupportoState> {
  constructor() {
    super([]);
  }
}
